import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { LOCAL_STORAGE_TOKEN } from '../constants/constants';

export const authGuard: CanActivateFn = () => {
    const router = inject(Router);

    if (localStorage.getItem(LOCAL_STORAGE_TOKEN)) {
        return true;
    }

    return router.createUrlTree(['login']);
};
